"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _orderEntryFormConstants = require("../../../constants/sendOrder/orderEntryFormConstants.js");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper.js");
var _orderHelper = require("../../../helpers/orderHelper.js");
var _commonComponent = require("../../../propTypes/commonComponent.js");
var _OrderWarningModalComponent = _interopRequireDefault(require("../../ConfirmOrderModal/OrderWarningModalComponent.js"));
var _index = _interopRequireDefault(require("../../ConfirmOrderModal/index.js"));
var _APButton = _interopRequireDefault(require("../../common/APButton.js"));
var _index2 = _interopRequireDefault(require("../../common/APSegmentedButton/index.js"));
var _VerificationRequiredContainer = _interopRequireDefault(require("../../VerificationRequired/VerificationRequiredContainer.js"));
var _OrderEntryEstimates = require("../common/OrderEntryEstimates.js");
var _BuySellTabs = _interopRequireDefault(require("./BuySellTabs"));
var _FormAmountFields = require("../common/FormAmountFields.js");
require("../../../styles/components/TradeComponent.css");
require("./OrderEntry.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var baseClass = 'order-entry';
var baseClasses = (0, _cssClassesHelper.getBEMClasses)(baseClass);
var tradeComponentClasses = (0, _cssClassesHelper.getBEMClasses)('trade-component');
var OrderEntryAnchoringComponent = function OrderEntryAnchoringComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var openAdvancedOrderSidePane = props.openAdvancedOrderSidePane,
    openReportBlockTradeSidePane = props.openReportBlockTradeSidePane,
    side = props.side,
    isBuy = props.isBuy,
    handleSubmit = props.handleSubmit,
    submitting = props.submitting,
    invalid = props.invalid,
    disableTrading = props.disableTrading,
    isMarginActive = props.isMarginActive,
    title = props.title,
    allowBlockTrading = props.allowBlockTrading,
    reduxFormChange = props.reduxFormChange,
    maxQuantity = props.maxQuantity,
    form = props.form,
    _props$hasCredit = props.hasCredit,
    hasCredit = _props$hasCredit === void 0 ? false : _props$hasCredit;
  var resetState = (0, _react.useCallback)(function () {
    reduxFormChange('limitPrice', '');
    reduxFormChange('stopPrice', '');
    reduxFormChange('value', '');
    reduxFormChange('quantity', '');
  }, [reduxFormChange]);

  // reset form's state when user changes the buy/sell tabs
  (0, _react.useEffect)(resetState, [isBuy, isMarginActive, resetState]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(baseClasses())
  }, title || null, /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit,
    className: baseClasses('form')
  }, /*#__PURE__*/_react["default"].createElement(_BuySellTabs["default"], {
    baseClass: baseClass,
    styleName: !isBuy ? _commonComponent.styleNames.subtractive : _commonComponent.styleNames.additive
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('order-type-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_index2["default"], {
    name: "orderType",
    label: t('Order Type'),
    items: [{
      value: _orderEntryFormConstants.orderTypes.market.displayName,
      text: t('Market'),
      dataTest: 'Market Order Type',
      title: t('Buy or sell at the best available price'),
      onClick: resetState
    }, {
      value: _orderEntryFormConstants.orderTypes.limit.displayName,
      text: t('Limit'),
      dataTest: 'Limit Order Type',
      title: t('Buy or sell at the specified price or better'),
      onClick: resetState
    }, {
      value: _orderEntryFormConstants.orderTypes.stopMarket.displayName,
      text: t('Stop'),
      dataTest: 'Stop Order Type',
      title: t('Buy or sell once the price reaches a specified Stop Price'),
      onClick: resetState
    }],
    customClass: baseClass,
    styleName: isBuy ? _commonComponent.styleNames.additive : _commonComponent.styleNames.subtractive
  })), /*#__PURE__*/_react["default"].createElement(_FormAmountFields.FormAmountFields, {
    baseClass: baseClass,
    formName: form,
    maxQuantity: maxQuantity,
    hasCredit: hasCredit
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: tradeComponentClasses('section detail')
  }, /*#__PURE__*/_react["default"].createElement(_OrderEntryEstimates.OrderEntryEstimates, {
    baseClass: baseClasses(),
    formName: form,
    isMarginActive: isMarginActive
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: tradeComponentClasses('section')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    disabled: submitting || invalid || disableTrading || !hasCredit && !maxQuantity,
    customClass: baseClass,
    styleName: isBuy ? _commonComponent.styleNames.additive : _commonComponent.styleNames.subtractive
  }, submitting ? t('Processing...') : t((0, _orderHelper.getSubmitButtonText)(side))), /*#__PURE__*/_react["default"].createElement(_VerificationRequiredContainer["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: tradeComponentClasses('section')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(baseClasses('item-button')),
    onClick: openAdvancedOrderSidePane
  }, "\xAB ".concat(t('Advanced Orders')))), allowBlockTrading && /*#__PURE__*/_react["default"].createElement("div", {
    className: tradeComponentClasses('section')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(baseClasses('item-button')),
    onClick: openReportBlockTradeSidePane
  }, "\xAB ".concat(t('Report Block Trade')))))), /*#__PURE__*/_react["default"].createElement(_OrderWarningModalComponent["default"], null), /*#__PURE__*/_react["default"].createElement(_index["default"], null));
};
OrderEntryAnchoringComponent.defaultProps = {
  submitting: false,
  isMarginActive: false,
  allowBlockTrading: false
};
OrderEntryAnchoringComponent.propTypes = {
  handleSubmit: _propTypes["default"].func.isRequired,
  allowBlockTrading: _propTypes["default"].bool,
  openAdvancedOrderSidePane: _propTypes["default"].func.isRequired,
  openReportBlockTradeSidePane: _propTypes["default"].func.isRequired,
  orderEntryForm: _propTypes["default"].object.isRequired,
  submitting: _propTypes["default"].bool,
  invalid: _propTypes["default"].bool.isRequired,
  disableTrading: _propTypes["default"].bool.isRequired,
  VerificationRequiredComponent: _propTypes["default"].element,
  side: _propTypes["default"].string.isRequired,
  isBuy: _propTypes["default"].bool.isRequired,
  isMarginActive: _propTypes["default"].bool.isRequired,
  maxQuantity: _propTypes["default"].number.isRequired
};
var _default = exports["default"] = OrderEntryAnchoringComponent;